import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../../app-error/app-error.model";

import { RealityCheckData } from "./reality-check.model";

const ACTION_PREFIX = "[Reality Check]";
export const REALITY_CHECK_ACTION_TYPE = {
	startTimer: `${ACTION_PREFIX} Start Timer ${SYNC_SUFFIX}`,
	stopTimer: `${ACTION_PREFIX} Stop Timer ${SYNC_SUFFIX}`,
	saveNextPulse: `${ACTION_PREFIX} Update Next Pulse ${SYNC_SUFFIX}`,

	/**
	 * Restarts the reality check timer and retrieves the bet summary in the last reality check time window.
	 */
	timerPulse: `${ACTION_PREFIX} Timer Pulse`,
	timerPulseSuccess: `${ACTION_PREFIX} Timer Pulse Success`,
	timerPulseFail: `${ACTION_PREFIX} Timer Pulse Fail`,

	disableRealityCheck: `${ACTION_PREFIX} Disable Reality Check ${SYNC_SUFFIX}`,
	setIsGlobalRealityCheckEnabled: `${ACTION_PREFIX} Set Global Reality Check Enabled ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class RealityCheckAction {
	startTimer(): Action {
		return {
			type: REALITY_CHECK_ACTION_TYPE.startTimer,
		};
	}

	stopTimer(): Action {
		return {
			type: REALITY_CHECK_ACTION_TYPE.stopTimer,
		};
	}

	/**
	 * Reality Check State is saved in local storage, thus this allows us to resume the reality check on refresh.
	 */
	saveNextPulse(payload: number): ActionWithPayload<number> {
		return {
			type: REALITY_CHECK_ACTION_TYPE.saveNextPulse,
			payload,
		};
	}

	timerPulse(): Action {
		return {
			type: REALITY_CHECK_ACTION_TYPE.timerPulse,
		};
	}

	timerPulseSuccess(payload: RealityCheckData): ActionWithPayload {
		return {
			type: REALITY_CHECK_ACTION_TYPE.timerPulseSuccess,
			payload,
		};
	}

	timerPulseFail(payload: AppError): ActionWithPayload {
		return {
			type: REALITY_CHECK_ACTION_TYPE.timerPulseFail,
			payload,
		};
	}

	disableRealityCheck(): Action {
		return {
			type: REALITY_CHECK_ACTION_TYPE.disableRealityCheck,
		};
	}

	setIsGlobalRealityCheckEnabled(payload: boolean): ActionWithPayload {
		return {
			type: REALITY_CHECK_ACTION_TYPE.setIsGlobalRealityCheckEnabled,
			payload,
		};
	}
}
